import { _ as _assert_this_initialized } from "@swc/helpers/_/_assert_this_initialized";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _get } from "@swc/helpers/_/_get";
import { _ as _get_prototype_of } from "@swc/helpers/_/_get_prototype_of";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import { State } from "../../State";
import { DEFAULT_TOUCH_SLOP } from "../constants";
import GestureHandler from "./GestureHandler";
var DEFAULT_MIN_POINTERS = 1;
var DEFAULT_MAX_POINTERS = 10;
var DEFAULT_MIN_DIST_SQ = DEFAULT_TOUCH_SLOP * DEFAULT_TOUCH_SLOP;
var PanGestureHandler = /*#__PURE__*/ function(GestureHandler) {
    "use strict";
    _inherits(PanGestureHandler, GestureHandler);
    var _super = _create_super(PanGestureHandler);
    function PanGestureHandler() {
        _class_call_check(this, PanGestureHandler);
        var _this;
        _this = _super.apply(this, arguments);
        _define_property(_assert_this_initialized(_this), "customActivationProperties", [
            "activeOffsetXStart",
            "activeOffsetXEnd",
            "failOffsetXStart",
            "failOffsetXEnd",
            "activeOffsetYStart",
            "activeOffsetYEnd",
            "failOffsetYStart",
            "failOffsetYEnd",
            "minVelocityX",
            "minVelocityY"
        ]);
        _define_property(_assert_this_initialized(_this), "velocityX", 0);
        _define_property(_assert_this_initialized(_this), "velocityY", 0);
        _define_property(_assert_this_initialized(_this), "minDistSq", DEFAULT_MIN_DIST_SQ);
        _define_property(_assert_this_initialized(_this), "activeOffsetXStart", -Number.MAX_SAFE_INTEGER);
        _define_property(_assert_this_initialized(_this), "activeOffsetXEnd", Number.MIN_SAFE_INTEGER);
        _define_property(_assert_this_initialized(_this), "failOffsetXStart", Number.MIN_SAFE_INTEGER);
        _define_property(_assert_this_initialized(_this), "failOffsetXEnd", Number.MAX_SAFE_INTEGER);
        _define_property(_assert_this_initialized(_this), "activeOffsetYStart", Number.MAX_SAFE_INTEGER);
        _define_property(_assert_this_initialized(_this), "activeOffsetYEnd", Number.MIN_SAFE_INTEGER);
        _define_property(_assert_this_initialized(_this), "failOffsetYStart", Number.MIN_SAFE_INTEGER);
        _define_property(_assert_this_initialized(_this), "failOffsetYEnd", Number.MAX_SAFE_INTEGER);
        _define_property(_assert_this_initialized(_this), "minVelocityX", Number.MAX_SAFE_INTEGER);
        _define_property(_assert_this_initialized(_this), "minVelocityY", Number.MAX_SAFE_INTEGER);
        _define_property(_assert_this_initialized(_this), "minVelocitySq", Number.MAX_SAFE_INTEGER);
        _define_property(_assert_this_initialized(_this), "minPointers", DEFAULT_MIN_POINTERS);
        _define_property(_assert_this_initialized(_this), "maxPointers", DEFAULT_MAX_POINTERS);
        _define_property(_assert_this_initialized(_this), "startX", 0);
        _define_property(_assert_this_initialized(_this), "startY", 0);
        _define_property(_assert_this_initialized(_this), "offsetX", 0);
        _define_property(_assert_this_initialized(_this), "offsetY", 0);
        _define_property(_assert_this_initialized(_this), "lastX", 0);
        _define_property(_assert_this_initialized(_this), "lastY", 0);
        _define_property(_assert_this_initialized(_this), "activateAfterLongPress", 0);
        _define_property(_assert_this_initialized(_this), "activationTimeout", 0);
        return _this;
    }
    _create_class(PanGestureHandler, [
        {
            key: "init",
            value: function init(ref, propsRef) {
                _get(_get_prototype_of(PanGestureHandler.prototype), "init", this).call(this, ref, propsRef);
            }
        },
        {
            key: "updateGestureConfig",
            value: function updateGestureConfig(_param) {
                var _param_enabled = _param.enabled, enabled = _param_enabled === void 0 ? true : _param_enabled, props = _object_without_properties(_param, [
                    "enabled"
                ]);
                this.resetConfig();
                _get(_get_prototype_of(PanGestureHandler.prototype), "updateGestureConfig", this).call(this, _object_spread({
                    enabled: enabled
                }, props));
                this.checkCustomActivationCriteria(this.customActivationProperties);
                if (this.config.minDist !== undefined) {
                    this.minDistSq = this.config.minDist * this.config.minDist;
                } else if (this.hasCustomActivationCriteria) {
                    this.minDistSq = Number.MAX_SAFE_INTEGER;
                }
                if (this.config.minPointers !== undefined) {
                    this.minPointers = this.config.minPointers;
                }
                if (this.config.maxPointers !== undefined) {
                    this.maxPointers = this.config.maxPointers;
                }
                if (this.config.minVelocity !== undefined) {
                    this.minVelocityX = this.config.minVelocity;
                    this.minVelocityY = this.config.minVelocity;
                }
                if (this.config.minVelocityX !== undefined) {
                    this.minVelocityX = this.config.minVelocityX;
                }
                if (this.config.minVelocityY !== undefined) {
                    this.minVelocityY = this.config.minVelocityY;
                }
                if (this.config.activateAfterLongPress !== undefined) {
                    this.activateAfterLongPress = this.config.activateAfterLongPress;
                }
                if (this.config.activeOffsetXStart !== undefined) {
                    this.activeOffsetXStart = this.config.activeOffsetXStart;
                    if (this.config.activeOffsetXEnd === undefined) {
                        this.activeOffsetXEnd = Number.MAX_SAFE_INTEGER;
                    }
                }
                if (this.config.activeOffsetXEnd !== undefined) {
                    this.activeOffsetXEnd = this.config.activeOffsetXEnd;
                    if (this.config.activeOffsetXStart === undefined) {
                        this.activeOffsetXStart = Number.MIN_SAFE_INTEGER;
                    }
                }
                if (this.config.failOffsetXStart !== undefined) {
                    this.failOffsetXStart = this.config.failOffsetXStart;
                    if (this.config.failOffsetXEnd === undefined) {
                        this.failOffsetXEnd = Number.MAX_SAFE_INTEGER;
                    }
                }
                if (this.config.failOffsetXEnd !== undefined) {
                    this.failOffsetXEnd = this.config.failOffsetXEnd;
                    if (this.config.failOffsetXStart === undefined) {
                        this.failOffsetXStart = Number.MIN_SAFE_INTEGER;
                    }
                }
                if (this.config.activeOffsetYStart !== undefined) {
                    this.activeOffsetYStart = this.config.activeOffsetYStart;
                    if (this.config.activeOffsetYEnd === undefined) {
                        this.activeOffsetYEnd = Number.MAX_SAFE_INTEGER;
                    }
                }
                if (this.config.activeOffsetYEnd !== undefined) {
                    this.activeOffsetYEnd = this.config.activeOffsetYEnd;
                    if (this.config.activeOffsetYStart === undefined) {
                        this.activeOffsetYStart = Number.MIN_SAFE_INTEGER;
                    }
                }
                if (this.config.failOffsetYStart !== undefined) {
                    this.failOffsetYStart = this.config.failOffsetYStart;
                    if (this.config.failOffsetYEnd === undefined) {
                        this.failOffsetYEnd = Number.MAX_SAFE_INTEGER;
                    }
                }
                if (this.config.failOffsetYEnd !== undefined) {
                    this.failOffsetYEnd = this.config.failOffsetYEnd;
                    if (this.config.failOffsetYStart === undefined) {
                        this.failOffsetYStart = Number.MIN_SAFE_INTEGER;
                    }
                }
            }
        },
        {
            key: "resetConfig",
            value: function resetConfig() {
                _get(_get_prototype_of(PanGestureHandler.prototype), "resetConfig", this).call(this);
                this.activeOffsetXStart = -Number.MAX_SAFE_INTEGER;
                this.activeOffsetXEnd = Number.MIN_SAFE_INTEGER;
                this.failOffsetXStart = Number.MIN_SAFE_INTEGER;
                this.failOffsetXEnd = Number.MAX_SAFE_INTEGER;
                this.activeOffsetYStart = Number.MAX_SAFE_INTEGER;
                this.activeOffsetYEnd = Number.MIN_SAFE_INTEGER;
                this.failOffsetYStart = Number.MIN_SAFE_INTEGER;
                this.failOffsetYEnd = Number.MAX_SAFE_INTEGER;
                this.minVelocityX = Number.MAX_SAFE_INTEGER;
                this.minVelocityY = Number.MAX_SAFE_INTEGER;
                this.minVelocitySq = Number.MAX_SAFE_INTEGER;
                this.minDistSq = DEFAULT_MIN_DIST_SQ;
                this.minPointers = DEFAULT_MIN_POINTERS;
                this.maxPointers = DEFAULT_MAX_POINTERS;
                this.activateAfterLongPress = 0;
            }
        },
        {
            key: "transformNativeEvent",
            value: function transformNativeEvent() {
                var translationX = this.getTranslationX();
                var translationY = this.getTranslationY();
                return _object_spread_props(_object_spread({}, _get(_get_prototype_of(PanGestureHandler.prototype), "transformNativeEvent", this).call(this)), {
                    translationX: isNaN(translationX) ? 0 : translationX,
                    translationY: isNaN(translationY) ? 0 : translationY,
                    velocityX: this.velocityX,
                    velocityY: this.velocityY
                });
            }
        },
        {
            key: "getTranslationX",
            value: function getTranslationX() {
                return this.lastX - this.startX + this.offsetX;
            }
        },
        {
            key: "getTranslationY",
            value: function getTranslationY() {
                return this.lastY - this.startY + this.offsetY;
            }
        },
        {
            key: "clearActivationTimeout",
            value: function clearActivationTimeout() {
                clearTimeout(this.activationTimeout);
            }
        },
        {
            key: "onPointerDown",
            value: //EventsHandling
            function onPointerDown(event) {
                this.tracker.addToTracker(event);
                _get(_get_prototype_of(PanGestureHandler.prototype), "onPointerDown", this).call(this, event);
                this.lastX = this.tracker.getLastAvgX();
                this.lastY = this.tracker.getLastAvgY();
                this.tryBegin(event);
                this.checkBegan();
            }
        },
        {
            key: "onPointerAdd",
            value: function onPointerAdd(event) {
                this.tracker.addToTracker(event);
                _get(_get_prototype_of(PanGestureHandler.prototype), "onPointerAdd", this).call(this, event);
                this.tryBegin(event);
                this.offsetX += this.lastX - this.startX;
                this.offsetY += this.lastY - this.startY;
                this.lastX = this.tracker.getLastAvgX();
                this.lastY = this.tracker.getLastAvgY();
                this.startX = this.lastX;
                this.startY = this.lastY;
                if (this.tracker.getTrackedPointersCount() > this.maxPointers) {
                    if (this.currentState === State.ACTIVE) {
                        this.cancel();
                    } else {
                        this.fail();
                    }
                } else {
                    this.checkBegan();
                }
            }
        },
        {
            key: "onPointerUp",
            value: function onPointerUp(event) {
                _get(_get_prototype_of(PanGestureHandler.prototype), "onPointerUp", this).call(this, event);
                if (this.currentState === State.ACTIVE) {
                    this.lastX = this.tracker.getLastAvgX();
                    this.lastY = this.tracker.getLastAvgY();
                }
                this.tracker.removeFromTracker(event.pointerId);
                if (this.currentState === State.ACTIVE) {
                    this.end();
                } else {
                    this.resetProgress();
                    this.fail();
                }
            }
        },
        {
            key: "onPointerRemove",
            value: function onPointerRemove(event) {
                _get(_get_prototype_of(PanGestureHandler.prototype), "onPointerRemove", this).call(this, event);
                this.tracker.removeFromTracker(event.pointerId);
                this.offsetX += this.lastX - this.startX;
                this.offsetY += this.lastY - this.startY;
                this.lastX = this.tracker.getLastAvgX();
                this.lastY = this.tracker.getLastAvgY();
                this.startX = this.lastX;
                this.startY = this.lastY;
                if (!(this.currentState === State.ACTIVE && this.tracker.getTrackedPointersCount() < this.minPointers)) {
                    this.checkBegan();
                }
            }
        },
        {
            key: "onPointerMove",
            value: function onPointerMove(event) {
                this.tracker.track(event);
                this.lastX = this.tracker.getLastAvgX();
                this.lastY = this.tracker.getLastAvgY();
                this.velocityX = this.tracker.getVelocityX(event.pointerId);
                this.velocityY = this.tracker.getVelocityY(event.pointerId);
                this.checkBegan();
                _get(_get_prototype_of(PanGestureHandler.prototype), "onPointerMove", this).call(this, event);
            }
        },
        {
            key: "onPointerOutOfBounds",
            value: function onPointerOutOfBounds(event) {
                if (this.getShouldCancelWhenOutside()) {
                    return;
                }
                this.tracker.track(event);
                this.lastX = this.tracker.getLastAvgX();
                this.lastY = this.tracker.getLastAvgY();
                this.velocityX = this.tracker.getVelocityX(event.pointerId);
                this.velocityY = this.tracker.getVelocityY(event.pointerId);
                this.checkBegan();
                if (this.currentState === State.ACTIVE) {
                    _get(_get_prototype_of(PanGestureHandler.prototype), "onPointerOutOfBounds", this).call(this, event);
                }
            }
        },
        {
            key: "shouldActivate",
            value: function shouldActivate() {
                var dx = this.getTranslationX();
                if (this.activeOffsetXStart !== Number.MAX_SAFE_INTEGER && dx < this.activeOffsetXStart) {
                    return true;
                }
                if (this.activeOffsetXEnd !== Number.MIN_SAFE_INTEGER && dx > this.activeOffsetXEnd) {
                    return true;
                }
                var dy = this.getTranslationY();
                if (this.activeOffsetYStart !== Number.MAX_SAFE_INTEGER && dy < this.activeOffsetYStart) {
                    return true;
                }
                if (this.activeOffsetYEnd !== Number.MIN_SAFE_INTEGER && dy > this.activeOffsetYEnd) {
                    return true;
                }
                var distanceSq = dx * dx + dy * dy;
                if (this.minDistSq !== Number.MAX_SAFE_INTEGER && distanceSq >= this.minDistSq) {
                    return true;
                }
                var vx = this.velocityX;
                if (this.minVelocityX !== Number.MAX_SAFE_INTEGER && (this.minVelocityX < 0 && vx <= this.minVelocityX || this.minVelocityX >= 0 && this.minVelocityX <= vx)) {
                    return true;
                }
                var vy = this.velocityY;
                if (this.minVelocityY !== Number.MAX_SAFE_INTEGER && (this.minVelocityY < 0 && vy <= this.minVelocityY || this.minVelocityY >= 0 && this.minVelocityY <= vy)) {
                    return true;
                }
                var velocitySq = vx * vx + vy * vy;
                return this.minVelocitySq !== Number.MAX_SAFE_INTEGER && velocitySq >= this.minVelocitySq;
            }
        },
        {
            key: "shouldFail",
            value: function shouldFail() {
                var dx = this.getTranslationX();
                var dy = this.getTranslationY();
                var distanceSq = dx * dx + dy * dy;
                if (this.activateAfterLongPress > 0 && distanceSq > DEFAULT_MIN_DIST_SQ) {
                    this.clearActivationTimeout();
                    return true;
                }
                if (this.failOffsetXStart !== Number.MIN_SAFE_INTEGER && dx < this.failOffsetXStart) {
                    return true;
                }
                if (this.failOffsetXEnd !== Number.MAX_SAFE_INTEGER && dx > this.failOffsetXEnd) {
                    return true;
                }
                if (this.failOffsetYStart !== Number.MIN_SAFE_INTEGER && dy < this.failOffsetYStart) {
                    return true;
                }
                return this.failOffsetYEnd !== Number.MAX_SAFE_INTEGER && dy > this.failOffsetYEnd;
            }
        },
        {
            key: "tryBegin",
            value: function tryBegin(event) {
                var _this = this;
                if (this.currentState === State.UNDETERMINED && this.tracker.getTrackedPointersCount() >= this.minPointers) {
                    this.resetProgress();
                    this.offsetX = 0;
                    this.offsetY = 0;
                    this.velocityX = 0;
                    this.velocityY = 0;
                    this.begin();
                    if (this.activateAfterLongPress > 0) {
                        this.activationTimeout = setTimeout(function() {
                            _this.activate();
                        }, this.activateAfterLongPress);
                    }
                } else {
                    this.velocityX = this.tracker.getVelocityX(event.pointerId);
                    this.velocityY = this.tracker.getVelocityY(event.pointerId);
                }
            }
        },
        {
            key: "checkBegan",
            value: function checkBegan() {
                if (this.currentState === State.BEGAN) {
                    if (this.shouldFail()) {
                        this.fail();
                    } else if (this.shouldActivate()) {
                        this.activate();
                    }
                }
            }
        },
        {
            key: "activate",
            value: function activate() {
                var force = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                if (this.currentState !== State.ACTIVE) {
                    this.resetProgress();
                }
                _get(_get_prototype_of(PanGestureHandler.prototype), "activate", this).call(this, force);
            }
        },
        {
            key: "onCancel",
            value: function onCancel() {
                this.clearActivationTimeout();
            }
        },
        {
            key: "onReset",
            value: function onReset() {
                this.clearActivationTimeout();
            }
        },
        {
            key: "resetProgress",
            value: function resetProgress() {
                if (this.currentState === State.ACTIVE) {
                    return;
                }
                this.startX = this.lastX;
                this.startY = this.lastY;
            }
        }
    ]);
    return PanGestureHandler;
}(GestureHandler);
export { PanGestureHandler as default };
